import { useRef } from "react";
import { ErrorBoundary } from "react-error-boundary";

import styled from "styled-components/macro";

import { useGetCTAData } from "Giving/ManageMyGivingPage/API/queries";
import { motion } from "framer-motion";

import useIsWiderThan from "Utilities/Hooks/useIsWiderThan";

import CTA from "./CTA";

export default function CallsToAction() {
  const { data } = useGetCTAData();

  const animationVariants = {
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
    hidden: {},
  };

  const containerRef = useRef();

  const isWiderThan = useIsWiderThan(containerRef, { px: 700 });

  return (
    <ErrorBoundary fallbackRender={() => null}>
      <Wrapper
        initial="hidden"
        animate="visible"
        variants={animationVariants}
        ref={containerRef}
      >
        {data?.ctas?.map((cta) => {
          if (cta.fundDeleted) {
            return null;
          }
          return (
            <CTA
              key={cta.ID}
              type={cta.actionTypeID}
              fullWidth={!isWiderThan}
              newTab
              {...cta}
            />
          );
        })}
      </Wrapper>
    </ErrorBoundary>
  );
}

const Wrapper = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  margin-bottom: 60px;
`;
